module.exports = __webpack_public_path__ + "static/media/n_icon_video@2x.e86e7f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_video@2x.png
// module id = 1820
// module chunks = 0 1